import React from "react";
import QRCode from "qrcode";

export function buildTelUri(countryCode, mobileNumber) {
  const phoneDigits = String(mobileNumber || "").replace(/\D/g, "");
  if (!phoneDigits) return null;
  const countryDigits = String(countryCode || "").replace(/[^\d+]/g, "");
  return `tel:${`${countryDigits}${phoneDigits}`.replace(/[^\d+]/g, "")}`;
}

export async function generateMobileDialQrDataUrl(countryCode, mobileNumber, width = 240) {
  const telUri = buildTelUri(countryCode, mobileNumber);
  if (!telUri) return null;
  return QRCode.toDataURL(telUri, { width, margin: 1 });
}

export function MobileDialQrModal({ open, title, number, dataUrl, onClose }) {
  if (!open) return null;

  return (
    <div className="cportal-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="cportal-modal cportal-mobile-dial-qr-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="mobile-dial-qr-title"
      >
        <div className="cportal-modal-header">
          <h3 id="mobile-dial-qr-title">{title || "Dial QR"}</h3>
          <button type="button" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="cportal-mobile-dial-qr-modal-body">
          {dataUrl && (
            <img src={dataUrl} alt={number ? `QR code to dial ${number}` : "QR code to dial mobile number"} />
          )}
          {number && <p className="cportal-mobile-dial-qr-number">{number}</p>}
          <p className="cportal-mobile-dial-qr-hint">Scan with a phone camera to dial this number.</p>
        </div>
      </div>
    </div>
  );
}

export function MobileDialQrInline({ dataUrl, number, label = "Scan to dial" }) {
  if (!dataUrl) return null;

  return (
    <div className="cportal-mobile-dial-qr">
      <img src={dataUrl} alt={number ? `QR code to dial ${number}` : "QR code to dial mobile number"} />
      <span>{label}</span>
    </div>
  );
}
